import { Plugin } from '@tiptap/pm/state';
import { Node, ReactNodeViewRenderer, mergeAttributes } from '@tiptap/react';
import ZyTermNodeView from './zyterm-node-view';

export const ZyTermHeadless = Node.create({
    name: 'zyTerm',

    group: 'inline',

    inline: true,

    selectable: true,

    content: 'text*',

    addAttributes() {
        return {
            obeycase: {
                default: false,
                parseHTML: element => {
                    if (!(element instanceof HTMLElement)) {
                        return false;
                    }
                    return element.getAttribute('obeycase') === 'true';
                },
                renderHTML: () => ({
                    obeycase: 'true',
                }),
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'span.term[data-term="true"]',
                getAttrs: element => {
                    if (!(element instanceof HTMLElement)) return false;
                    if (element.getAttribute('data-term') !== 'true') return false;
                    // If the term is inside a zyDefn, don't match it
                    if (element.closest('span[data-definition="true"]')) return false;
                    if (element.getAttribute('data-zydefn-term') === 'true') return false;
                    return {};
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'span',
            mergeAttributes(HTMLAttributes, {
                class: 'term zyterm',
                'data-term': 'true',
            }),
            0,
        ];
    },

    addProseMirrorPlugins() {
        return [
            new Plugin({
                appendTransaction: (transactions, _oldState, newState) => {
                    if (!transactions.some(tr => tr.docChanged)) {
                        return null;
                    }

                    const bold = newState.schema.marks.bold;
                    const italic = newState.schema.marks.italic;
                    if (!bold || !italic) {
                        return null;
                    }

                    const { doc } = newState;
                    const tr = newState.tr;
                    let modified = false;

                    doc.descendants((node, pos) => {
                        if (node.type.name !== 'zyTerm') {
                            return;
                        }
                        const innerFrom = pos + 1;
                        const innerTo = pos + node.nodeSize - 1;
                        if (innerFrom >= innerTo) {
                            return;
                        }
                        let needsBold = false;
                        let needsItalic = false;
                        doc.nodesBetween(innerFrom, innerTo, innerNode => {
                            if (innerNode.isText) {
                                if (!bold.isInSet(innerNode.marks)) {
                                    needsBold = true;
                                }
                                if (!italic.isInSet(innerNode.marks)) {
                                    needsItalic = true;
                                }
                            }
                        });
                        if (needsBold) {
                            tr.addMark(innerFrom, innerTo, bold.create());
                            modified = true;
                        }
                        if (needsItalic) {
                            tr.addMark(innerFrom, innerTo, italic.create());
                            modified = true;
                        }
                    });

                    return modified ? tr : null;
                },
            }),
        ];
    },
});

export const ZyTerm = ZyTermHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyTermNodeView);
    },
});

export default ZyTerm;
